import React, { useState } from 'react';
import megenagna from '../../../assets/images/background/megnagna.jpg';


import MekeleStudent from '../../../assets/images/icons/mekelestudent.jpg';
import AccreditationModal from './AccreditationModal'; // Adjust the import path as necessary
import accreditationImage from '../../../assets/images/icons/admasmsc.jpg'; // Accreditation image 1
import accreditationImage1 from '../../../assets/images/meg_acc1.jpg'; // Accreditation image 2

const Megenagna = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage('');
  };

  return (
    <div>
      <div className="banner-slide">
        <img src={megenagna} alt="Transforming Lives at Our Private University" className="banner-image" />
        <div className="banner-content">
          <h2>Transforming Lives at Our Private University</h2>
          <div>We offer high-quality education and dedicated support, ensuring every student has a transformative experience.</div>
          <div>Join us to achieve your academic and personal goals in a nurturing environment.</div>
        </div>
      </div>

      <section className="projects-details">
        <div className="auto-container">
          <div className="sec-title style-two">
            <h3>MEGENAGNA CAMPUS</h3>
          </div>
          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <h4>MESSAGE FROM CAMPUS DEAN</h4>
                <div className="text">
                  <p>
                    Welcome to Admas University Megenagna Campus! We are dedicated to 
                    <strong> academic excellence, innovation, and student success</strong>. 
                    As one of Ethiopia’s leading private universities, we take pride in offering 
                    <strong> industry-relevant programs, modern learning facilities, and a dynamic educational environment</strong> 
                    that prepares students for the future.
                  </p>
                  <p>
                    Our commitment to <strong>quality education</strong> extends beyond the classroom, 
                    ensuring that students gain <em>practical skills, critical thinking abilities, and leadership qualities</em> 
                    to excel in today’s competitive world.
                  </p>
                  <p>
                    Join us in shaping the future! Whether you are a prospective student, researcher, or industry partner, 
                    <strong> Admas University Megenagna Campus</strong> is the place where <em>opportunity meets excellence</em>.
                  </p>
                  <h4>📍 Admas University Megenagna Campus – Your Future Starts Here!</h4>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="image pht">
             
                  <figcaption>Ahmed Seid (MBA)</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <div className="sec-title style-two">
                  <h4>ACCREDITED PROGRAMS</h4>
                </div>
                <h6>POSTGRADUATE PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Master of Business Administration</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Computer Science</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Project Management</div></li>
                </ul>

                <h6>UNDERGRADUATE PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Business Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Marketing Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Computer Science</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Hotel Management</div></li>
                </ul>

                <h6>TVET PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Hardware & Networking Servicing Level 1-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Marketing & Sales Management Level 2-4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance Level 2-4</div></li>
                </ul>
              </div>
              <div className="col-lg-6">
                  <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.4966434480443!2d38.79661448885497!3d9.018377200000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b857a588c696b%3A0x3704552a89c3f3ff!2sAdmas%20University%20%7C%20megenagna%20%7C!5e0!3m2!1sen!2set!4v1744795285700!5m2!1sen!2set"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Admas University Meskel Campus Location"
                  ></iframe>
                </div>
                <div className="accreditation">
                  <h5>CERTIFICATE OF ACCREDITATION</h5>
                  <img 
                    src={accreditationImage} 
                    alt="Accreditation Letter 1" 
                    style={{ width: '150px', cursor: 'pointer', marginRight: '10px' }} 
                    onClick={() => openModal(accreditationImage)} 
                  />
                  <img 
                    src={accreditationImage1} 
                    alt="Accreditation Letter 3" 
                    style={{ width: '150px', cursor: 'pointer' }} 
                    onClick={() => openModal(accreditationImage1)} 
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="text-block-two">
            <div className="row">
              <div className="col-lg-6">
                <h4>STUDENT LIFE @ MEGENAGNA CAMPUS</h4>
                <div className="text">
                  Megenagna Campus of Admas University stands out as the premier destination for learning, providing an enriching environment for both postgraduate and undergraduate students. With state-of-the-art facilities, dedicated faculty, and a vibrant student community, it fosters academic excellence and personal growth.
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image"><img src={MekeleStudent} alt="Student Life" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AccreditationModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        images={[accreditationImage, accreditationImage1]} 
      />
    </div>
  );
}

export default Megenagna;